/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HostNameAndCsvLinkData
 */
export interface HostNameAndCsvLinkData {
    /**
     * 
     * @type {string}
     * @memberof HostNameAndCsvLinkData
     */
    hostName?: string;
    /**
     * 
     * @type {string}
     * @memberof HostNameAndCsvLinkData
     */
    csvLink?: string;
}

/**
 * Check if a given object implements the HostNameAndCsvLinkData interface.
 */
export function instanceOfHostNameAndCsvLinkData(value: object): value is HostNameAndCsvLinkData {
    return true;
}

export function HostNameAndCsvLinkDataFromJSON(json: any): HostNameAndCsvLinkData {
    return HostNameAndCsvLinkDataFromJSONTyped(json, false);
}

export function HostNameAndCsvLinkDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): HostNameAndCsvLinkData {
    if (json == null) {
        return json;
    }
    return {
        
        'hostName': json['hostName'] == null ? undefined : json['hostName'],
        'csvLink': json['csvLink'] == null ? undefined : json['csvLink'],
    };
}

export function HostNameAndCsvLinkDataToJSON(json: any): HostNameAndCsvLinkData {
    return HostNameAndCsvLinkDataToJSONTyped(json, false);
}

export function HostNameAndCsvLinkDataToJSONTyped(value?: HostNameAndCsvLinkData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostName': value['hostName'],
        'csvLink': value['csvLink'],
    };
}

